/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSlideshowClassic = {
  init: function($section) {
    window.PXUTheme.jsSlideshowClassic = $.extend(this, window.PXUTheme.getSectionData($section));
    const $slideshowClassicEl = $section.find('[data-slideshow-classic]')
      .removeClass('is-hidden')
      .removeClass('is-ready');
    const $slideshowClassic = $slideshowClassicEl.flickity({
      wrapAround: true,
      adaptiveHeight: true,
      prevNextButtons: this.number_of_slides > 1 ? this.show_arrows : false,
      pageDots: this.number_of_slides > 1 ? this.show_nav_buttons : false,
      draggable: true,
      imagesLoaded: true,
      fade: this.image_transition == 'fade',
      autoPlay: this.image_slideshow_speed * 1000,
      arrowShape: arrowShape
    });
    $slideshowClassic.on('ready.flickity', function () {
      $slideshowClassicEl.addClass('is-ready');
    });
    $slideshowClassicEl.one('settle.flickity', function () {
      $slideshowClassicEl.addClass('is-ready');
      $slideshowClassicEl.flickity('resize');
    });
  },
  blockSelect: function($section, blockId) {
    const $slider = $section.find('[data-image-slideshow]');
    const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');
    $slider.flickity('select', $sliderIndex, true, true);
  },
  unload: function($section) {}
}
/******/ })()
;
